import {
    createSlice,
} from '@reduxjs/toolkit'

const initalState = {
    holiday: ""
}

const themeSlice = createSlice({
    name: 'theme',
    initialState: initalState,
    reducers: {
        changeHolidayTheme(state, {payload: theme}) {
            state.holiday = theme
        }
    },
})

export default themeSlice.reducer

export const {changeHolidayTheme} = themeSlice.actions;